import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { ACCOUNT_NAVIGATION, ROUTES } from '../../../assets/constants/strings';
import SettingsTitle from '../SettingsTitle';
import Loader from '../../Loader';
import {
  isReaderEnterprise,
  isReaderTrial,
  readerPlanName,
  readerTrialEndsAt,
  readerTrialDaysLeft,
  readerSeats,
  readerRenewalDate,
  readerNegotiatedPrice,
} from '../../../services/entitlements';

// Reader membership summary. Self-serve billing is retired — reader access is now
// Trial (self-serve, time-boxed) or Enterprise (sales-provisioned, we set the
// price), so there is no payment method / checkout here. This just reflects the
// current plan from the entitlement subscription and links to the Plans page.
const MembershipInfo = ({ user, loading }) => {
  const enterprise = isReaderEnterprise(user);
  const trial = isReaderTrial(user);
  const daysLeft = readerTrialDaysLeft(user);
  const trialEnds = readerTrialEndsAt(user);

  const planLabel = enterprise
    ? 'Enterprise'
    : trial
    ? 'Trial'
    : readerPlanName(user) || 'Free';

  const statusValue = enterprise
    ? 'Active'
    : trial
    ? daysLeft > 0
      ? `Trial — ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left`
      : 'Trial ended'
    : 'Active';

  // Enterprise deal terms the customer can see (seats, renewal date, agreed price).
  const seats = readerSeats(user);
  const renewal = readerRenewalDate(user);
  const price = readerNegotiatedPrice(user);
  const priceLabel = price
    ? `$${Number(price.amount).toLocaleString()}${
        price.interval === 'Annual'
          ? '/year'
          : price.interval === 'Monthly'
          ? '/month'
          : ''
      }`
    : null;

  const rows = [
    { TEXT: 'Current Plan:', VALUE: planLabel },
    { TEXT: 'Status:', VALUE: statusValue },
    trial && trialEnds
      ? {
          TEXT: 'Trial Ends:',
          VALUE: moment(trialEnds).format('D MMM YYYY'),
        }
      : null,
    enterprise && seats ? { TEXT: 'Seats:', VALUE: seats } : null,
    enterprise && renewal
      ? { TEXT: 'Renewal Date:', VALUE: moment(renewal).format('D MMM YYYY') }
      : null,
    enterprise && priceLabel
      ? { TEXT: 'Contract Value:', VALUE: priceLabel }
      : null,
  ];

  return (
    <div id='membership' className='membership-frame'>
      <SettingsTitle title={ACCOUNT_NAVIGATION.MEMBERSHIP.TITLE} />
      {!loading ? (
        <div className='membership-info'>
          {rows.map(
            (item, i) =>
              item !== null && (
                <div key={i} className='membership-info__row'>
                  <label>{item.TEXT}</label>
                  <span className='membership-info__row__value'>
                    {item.VALUE}
                  </span>
                </div>
              )
          )}
          <div className='membership-info__row__buttons mt-4'>
            <Link className='my-account-btn' to={ROUTES.SELECT_PLANS}>
              {enterprise ? 'View plans' : 'View plans & Enterprise'}
            </Link>
          </div>
        </div>
      ) : (
        <div className='inner-load'>
          <Loader />
        </div>
      )}
    </div>
  );
};

export default MembershipInfo;
